// src/modules/Produto/boot/index.js
import { bootProdutoCommon } from './bootProdutoCommon';
import { bootProdutoCategoria } from './bootProdutoCategoria';

export const applyProdutoBoot = ({ prev, categoria, parametro }) => {
    let next = prev;

    // comum
    next = bootProdutoCommon({ prev: next });

    // categoria
    next = bootProdutoCategoria({ prev: next, categoria, parametro });

    return next;
};
